export const isNum = (value) => typeof value === 'number' && Number.isFinite(value);

// Never prints "-0.0": a value that rounds to zero is shown unsigned.
export const formatNumber = (value, digits = 1) => {
  if (!isNum(value)) {
    return '--';
  }
  const text = value.toFixed(digits);
  return Number(text) === 0 ? (0).toFixed(digits) : text;
};

export const formatOrm = (value) => (isNum(value) ? `${formatNumber(value, 1)} lb` : '--');

// Turns a code like "ChestPress" into "Chest press" for display.
export const humanizeCode = (code) => {
  const words = String(code || '')
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim()
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

// Signed text with an arrow so direction never relies on color alone.
export const describeChange = (value) => {
  if (!isNum(value)) {
    return { arrow: '', text: 'no baseline yet', direction: 'none' };
  }
  const rounded = Math.round(value * 10) / 10;
  if (rounded === 0) {
    return { arrow: '→', text: '0.0%', direction: 'flat' };
  }
  const up = rounded > 0;
  return {
    arrow: up ? '▲' : '▼',
    text: `${up ? '+' : '-'}${Math.abs(rounded).toFixed(1)}%`,
    direction: up ? 'up' : 'down',
  };
};

export const hasExerciseData = (exercise) => isNum(exercise?.currentOrm);

export const formatDate = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
